var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"char-counter",class:{
        'char-counter--error': _vm.remaining < 0,
        'char-counter--warning': _vm.warningMax && _vm.warningMax < _vm.count,
    }},[_vm._v(" "+_vm._s(_vm.remaining)+" / "+_vm._s(_vm.max)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }